export default __webpack_public_path__ + "static/media/icon-cashback-checkmark.3d971711.svg";